/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll"], function () {
    const module = this;

    const MobMenu = function () {
        this.parentClass = "js-mobmenu";
        this.parent = document.querySelector("." + this.parentClass);
        this.toggleBtns = document.querySelector(".js-mobmenu-toggle");
        this.openedClass = "is-opened";
        this.activeClass = "is-active";
        this.opened = false;
        this.$body = itsoftApp.commonVars.$body;
        this.expandedBlocks = document.querySelector(".js-mobmenu-expand");
        this.fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
        this.getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
        this.menuLinks = document.querySelectorAll(".js-link");

        if (!this.toggleBtns > 0) {
            return;
        }

        this.init();
    };

    MobMenu.prototype.openMenu = function () {
        if (this.opened) {
            return;
        }
        this.opened = true;

        if (this.fixedPageElems) {
            const scrollbarWidth = this.getScrollbarWidth();
            DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
            Array.prototype.forEach.call(this.fixedPageElems, function (el) {
                el.style.paddingRight = scrollbarWidth + "px";
            });
        }

        this.toggleBtns.classList.add(this.activeClass);
        this.parent.classList.add(this.openedClass);
        document.documentElement.style.overflow = "hidden"; // NOTE: Отменил прокрутку
        DEBUG && console.log("[module mobMenu] menu opened");
    };

    MobMenu.prototype.closeMenu = function () {
        if (!this.opened) {
            return;
        }
        this.opened = false;
        if (this.fixedPageElems) {
            Array.prototype.forEach.call(this.fixedPageElems, function (el) {
                el.style.paddingRight = "0";
            });
        }
        document.documentElement.style.overflow = "visible"; // NOTE: Вернул прокрутку

        this.toggleBtns.classList.remove(this.activeClass);
        this.parent.classList.remove(this.openedClass);
        DEBUG && console.log("[module mobMenu] menu closed");
    };

    MobMenu.prototype.toggleBtnClick = function (evt) {
        const MOBMENU = this;
        evt.preventDefault();
        if (this.opened) {
            MOBMENU.closeMenu();
        } else {
            MOBMENU.openMenu();
        }
    };

    /**
     * Обработчик события пролистывания страницы.
     * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
     *
     * @param  {number} y Текущее значение прокрутки страницы
     */
    MobMenu.prototype.scrollController = function (y) {
        const MOBMENU = this;
        if (!this.opened) {
            return;
        }
        // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
        // но на всякий случай пропишем fallback.
        y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;

        const menuHeight = this.parent.offsetHeight + this.expandedBlocks.offsetHeight;

        // if (y > menuHeight + 20) {
        if (y + menuHeight > menuHeight + menuHeight / 3) {
            MOBMENU.closeMenu();
        }
    };

    /**
     * Как и в случае со всплывашками на сайте,
     * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
     * то пользователь интуитивно ожидает, что меню закроется.
     * Данный обработчик как раз для этого.
     *
     * @param  {object} e Event
     */
    MobMenu.prototype.bodyClick = function (e) {
        const MOBMENU = this;
        if (!this.opened) {
            return;
        }

        const target = e.target;
        const hasParent = target.closest("." + this.parentClass);

        // Закрываем меню, только если клик произошёл
        // по элементу вне пределов родительского блока
        // (по сути - клик по любой точке экрана, кроме меню).
        if (!hasParent) {
            MOBMENU.closeMenu();

            // Отмена действия по умолчанию
            // (например, чтобы не произошёл переход по ссылке, если
            // мы кликнули по элементу <a>).
            return false;
        }
    };

    MobMenu.prototype.addListeners = function () {
        const MOBMENU = this;
        // Привязка событий и функций-обработчиков
        this.toggleBtns.addEventListener("click", MOBMENU.toggleBtnClick.bind(MOBMENU));
        this.$body.addEventListener("click", MOBMENU.bodyClick(MOBMENU));

        // NOTE: Выловили нелепый баг, на айпадике.
        // Без строчки ниже не срабатывало событие click у верхнего элемента body.
        // Говно, дерьмо, жопа :D
        itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});

        Array.prototype.forEach.call(this.menuLinks, function (el) {
            el.addEventListener("click", function () {
                // if (currentOpenedPopup) {
                //     currentOpenedPopup.dispatchEvent(closeEvent);
                // }
                MOBMENU.closeMenu();
            });
        });
    };

    MobMenu.prototype.init = function () {
        if (!this.parent) {
            return false;
        }
        const MOBMENU = this;
        // Инициализируем слушатели событий
        this.addListeners();

        // Делегируем функцию в модуль windowScroll
        // (единая точка входа для события "scroll").
        DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
        itsoftApp.modules.windowScroll.addEvent(MOBMENU.scrollController.bind(MOBMENU));
    };

    new MobMenu();
    module.callback = MobMenu;
});
